import React, { useState } from 'react';
import { startCheckout } from '../services/billingService';
import './PaywallModal.css';

/**
 * Full-screen modal shown when a user runs out of credits.
 *
 * Props:
 *   onClose  – called when the user dismisses the modal
 *   availableCredits  – current balance (may be 0)
 *   requiredCredits   – credits needed for the blocked action
 */
export default function PaywallModal({ onClose, availableCredits = 0, requiredCredits = 5 }) {
  const [buying, setBuying] = useState(false);

  const handleBuy = async () => {
    setBuying(true);
    try {
      await startCheckout('launch_pack');
    } catch (err) {
      console.error('Checkout error:', err);
      setBuying(false);
    }
  };

  return (
    <div className="paywall-overlay" role="dialog" aria-modal="true" aria-label="Buy credits">
      <div className="paywall-modal">
        <button className="paywall-modal__close" onClick={onClose} aria-label="Close">✕</button>

        <div className="paywall-modal__icon">◈</div>

        <h2 className="paywall-modal__title">
          {availableCredits === 0 ? 'No credits remaining' : 'Not enough credits'}
        </h2>
        <p className="paywall-modal__subtitle">
          You need <strong>{requiredCredits} credits</strong> to generate a blog.
          You currently have <strong>{availableCredits} credit{availableCredits !== 1 ? 's' : ''}</strong>.
        </p>

        <div className="paywall-modal__pack">
          <div className="paywall-modal__pack-header">
            <span className="paywall-modal__pack-label">Pay as you go</span>
          </div>
          <div className="paywall-modal__pack-price">$10</div>
          <ul className="paywall-modal__pack-features">
            <li>✓ 30 SEO blogs</li>
            <li>✓ 150 publishing credits</li>
            <li>✓ No monthly subscription</li>
            <li>✓ Credits never expire</li>
          </ul>
          <button
            className="paywall-modal__buy-btn"
            onClick={handleBuy}
            disabled={buying}
          >
            {buying ? 'Redirecting to checkout…' : 'Buy 150 credits - $10'}
          </button>
        </div>

        <p className="paywall-modal__note">
          Secure payment via Stripe. One-time purchase, no subscription.
        </p>
      </div>
    </div>
  );
}
